import type { ConfluenceEntity, Maybe, SearchResult } from '../../../../common/types';

const SearchConfluencePageBlogAttachment = `
... on SearchConfluencePageBlogAttachment {
	lastModified
	isVerified
	space {
		id
		name
		webUiLink
	}
	__typename
	confluenceEntity {
		... on ConfluencePage {
			subtype
			properties(keys: ["cover-picture-id-published", "cover-picture-id-draft"]) {
				key
				value
			}
			ancestors {
				id
				title
				links {
					webUi
				}
			}
			metadata {
				titleEmojiPublished {
					id
					value
				}
			}
			commentCountSummary {
				total
			}
			likesSummary {
				count
			}
		}
		... on ConfluenceBlogPost {
			properties(keys: ["cover-picture-id-published", "cover-picture-id-draft"]) {
				key
				value
			}
			metadata {
				titleEmojiPublished {
					id
					value
				}
			}
		}
	}
	socialSignal(tenantId: $tenantId) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}
	}
}
`;

export interface SearchConfluencePageBlogAttachment extends SearchResult {
	__typename: 'SearchConfluencePageBlogAttachment';
	confluenceEntity?: Maybe<ConfluenceEntity>;
	isVerified: boolean | null;
	lastModified?: Maybe<string>;
	socialSignal: Maybe<{
		/** Should be either "comment" , "edit", or "share". */
		signal: Maybe<string>;
		timestamp: Maybe<string>;
		user: Maybe<{
			accountId: string;
			email: Maybe<string>;
			extendedProfile: Maybe<{
				jobTitle: Maybe<string>;
			}>;
			name: string;
			picture: string;
		}>;
	}>;
	space?: Maybe<{
		id: string;
		name: string;
		webUiLink?: string;
	}>;
}

export const isSearchConfluencePageBlogAttachment = (
	partial: SearchResult,
): partial is SearchConfluencePageBlogAttachment => {
	return partial.__typename === 'SearchConfluencePageBlogAttachment';
};

const SearchConfluenceSpace = `
... on SearchConfluenceSpace {
	key
	lastModified
	iconPath
	socialSignal(tenantId: $tenantId) {
		signal
		timestamp
		user {
			accountId
			name
			picture
			... on AtlassianAccountUser {
				email
				extendedProfile {
					jobTitle
				}
			}
		}

	}
}
`;

export interface SearchConfluenceSpace extends SearchResult {
	__typename: 'SearchConfluenceSpace';
	iconPath?: Maybe<string>;
	key?: string;
	lastModified?: Maybe<string>;
	socialSignal: Maybe<{
		/** Should be either "comment" , "edit", or "share". */
		signal: Maybe<string>;
		timestamp: Maybe<string>;
		user: Maybe<{
			accountId: string;
			email: Maybe<string>;
			extendedProfile: Maybe<{
				jobTitle: Maybe<string>;
			}>;
			name: string;
			picture: string;
		}>;
	}>;
}

export const isSearchConfluenceSpace = (
	partial: SearchResult,
): partial is SearchConfluenceSpace => {
	return partial.__typename === 'SearchConfluenceSpace';
};

export type SearchConfluencePartial = SearchConfluencePageBlogAttachment | SearchConfluenceSpace;

export const isSearchConfluencePartial = (
	partial: SearchResult,
): partial is SearchConfluencePartial => {
	return isSearchConfluencePageBlogAttachment(partial) || isSearchConfluenceSpace(partial);
};

export const getConfluencePartials = () => {
	return `
		${SearchConfluencePageBlogAttachment}
		${SearchConfluenceSpace}
	`;
};
